function computeColumnCount(
	isMd: boolean | undefined,
	isLg: boolean | undefined,
	is1XL: boolean | undefined,
	is2XL: boolean | undefined,
) {
	if (is2XL) {
		return 6
	} else if (is1XL) {
		return 5
	} else if (isLg) {
		return 4
	} else if (isMd) {
		return 3
	}

	return 2
}

function getColumnWidthPercentage(columnCount: number) {
	switch (columnCount) {
		case 6:
			return 16.6667
		case 5:
			return 20
		case 4:
			return 25
		case 3:
			return 33.3333
		default:
			return 50
	}
}

function useMasonryColumnCount(containerWidth: number) {
	const isMd = containerWidth > 768
	const isLg = containerWidth > 1024
	const is1XL = containerWidth > 1280
	const is2XL = containerWidth > 1536

	const columnCount = computeColumnCount(isMd, isLg, is1XL, is2XL)

	return [columnCount, getColumnWidthPercentage(columnCount)]
}

export default useMasonryColumnCount
